function reportColumns(handleSendPdf) {
  return [
    {
      Header: "Customer",
      accessor: "name",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Phone",
      accessor: "phone",
      disableFilters: true,
      filterable: true,
    },
    {
      Header: "Qty",
      accessor: "total_qty",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value.toFixed(2)}</>,
    },
    {
      Header: "Amount",
      accessor: "total_amount",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => <>{value.toFixed(2)}</>,
    },
    {
      Header: "Total Orders",
      accessor: "orders",
      disableFilters: true,
      filterable: true,
      Cell: ({ value }) => (
        <span className={`badge ${value ? "bg-success" : "bg-warning"}`}>
          {value ? value.length : 0}
        </span>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: ({ row }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleSendPdf(row.original)}
        >
          Send PDF
        </button>
      ),
    },
  ];
}
export default reportColumns;
